import "./App.css";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import Home from "./components/Home";
import Register from "./components/Register";
import Login from "./components/Login";
// import Profile from './components/Profile';
// import UserNav from './components/UserNav';

import EventDetails from "./components/EventDetails";
import ResetPasswordMail from "./components/ResetPasswordMail";
import ResetPasswordLink from "./components/ResetPasswordLink";
import Message from "./components/Message";
import TeamReveal from "./components/TeamReveal";
import Contributors from "./components/Contributors";
import { useSelector } from "react-redux";
// import './styles/loader.css';
import Loader from "./components/Loader";
import QuizPage from "./components/Quiz";
import UserProfile from "./components/profilePage";
import UpcomingEvent from "./components/upcomingEvent";

function App() {
  const userStoreData = useSelector((store) => store.users);
  const eventStoreData = useSelector((store) => store.event);
  const quizStoreData = useSelector((store) => store.quiz);
  const teamStoreData = useSelector((store) => store.team);

  const { loading: userLoading } = userStoreData;
  const { loading: eventLoading } = eventStoreData;
  const { loading: quizLoading } = quizStoreData;
  const { loading: teamLoading } = teamStoreData;

  return (
    <div className="App" style={{ zIndex: 10, position: "relative" }}>
      {userLoading || eventLoading || quizLoading || teamLoading ? (
        <Loader />
      ) : null}

      {/* <Message/> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/Userprofile" element={<UserProfile />} />
          <Route path="/team" element={<TeamReveal />} />
          <Route path="/Questions" element={<QuizPage />} />
          <Route path="/events/:eventId" element={<EventDetails />} />
          <Route
            path="/forgot-password-reset/:token"
            element={<ResetPasswordLink />}
          />
          <Route
            path="/forgot-password-reset"
            element={<ResetPasswordMail />}
          />
          <Route path="/upcomingevent" element={<UpcomingEvent />} />
          <Route path="/contributors" element={<Contributors />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
